import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-congres-virtuel-conferences',
  templateUrl: './congres-virtuel-conferences.component.html',
  styleUrls: ['./congres-virtuel-conferences.component.scss']
})
export class CongresVirtuelConferencesComponent implements OnInit {

  sessions = {
    session_1:{ref:1, theme:"Session Jeunes Cardiologues :<br> <span>les MINOCA et diagnostics différentiels</span>", 
    moderateurs:"Z. Lakhal, L.Bendriss, T. El Kendoussi, N. Mouine, N. Fellat, N.Fekri", 
    temps:"Jeudi 15 Octobre 2020 - Après Midi / De 14H00 à 16H00",
    lives:[
      {nom:"A. Chachi", accro:"A.C", info:"Dissection coronaire", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/A.Chachi.png"},
     
      {nom:"H. Aissaoui", accro:"H.E", info:"Spasme coronaire", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/H.Aissaoui.png"},
     
      {nom:"O. Ammor", accro:"O.A", info:"Embolie coronaire ", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/O.Ammor.png"},
     
      {nom:"M. Bouziane", accro:"M.B", info:"Myocardite", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/M.Bouziane.png"},
     
      {nom:"T. El Ghali", accro:"T.E", info:"Tako tsubo", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/T.El Ghali.png"},
     
      {nom:"K.Marhoum El Filali", accro:"K.M.E", info:"Symposium Sanofi : Intérêt de la vaccination antigrippale dans le contexte actuel", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/K.Marhoum El Filali.png"},
    ]},

    session_2:{ref:2, theme:"Session imagerie :<br> <span>Imagerie multi-modalités en pratique clinique</span>", 
    moderateurs:"R. Benzidia, H. Belghiti, Z. Raissouni, A. Aouad", 
    temps:"Jeudi 15 Octobre 2020 - Après Midi / De 16H30 à 18H45",
    lives:[
      {nom:"A. Aouad", accro:"A.A", info:"Imagerie multi-modalités au cours de la sténose aortique", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/Aicha_Aouad.png"},
      
      {nom:"S. Edhery", accro:"S.E", info:"Imagerie multi-modalités dans le suivi de la cardiotoxicité de la chimiothérapie.", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/S.Ederhy.png"},
      
      {nom:"I. Asfalou", accro:"I.A", info:"Imagerie multi-modalités au cours des syndromes coronaires chroniques", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/I.Asfalou.png"},
      
      {nom:"E. Donal", accro:"E.D", info:"Imagerie multi-modalités chez les patients avec HVG", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/E.Donal.png"},

      {nom:"A. Cohen", accro:"A.C", info:"Imagerie multi-modalités dans le diagnostic des sources cardiaques d’embolie", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/A.Cohen.png"},
    ]},

    session_3:{ref:3, theme:"Session commune :<br> <span>SMC- GRCI</span>", 
    moderateurs:"K. Boughalem, R. Cherradi , D. Benzeroual, M. Allaoui, M. Zbir", 
    temps:"Jeudi 15 Octobre 2020 - Après Midi / De 19H15 à 20H45",
    lives:[
      {nom:"E. Teiger", accro:"E.T", info:"La ponction écho guidée : réussir sa ponction", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/E.Teiger.png"},
     
      {nom:"Z. Bazid", accro:"Z.B", info:"Comment gérer une radiale hostile ?", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/z.bazid.png"},
     
      {nom:"G. Bennouna", accro:"G.B", info:"Traitement des lésions ostiales", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/G.Bennouna.png"},
     
      {nom:"K. Boughalem", accro:"K.B", info:"Lésions résistantes : choix des ballons", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/K.Boughalem.png"},
     
      {nom:"A. Bouzerda", accro:"A.B", info:"Gestion du thrombus per-procédure", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/A.Bouzerda.png"},

      {nom:"C. Brasselet", accro:"C.B", info:"Comment fermer une fémorale : moyens et techniques ?", 
      zoom_co_link:"https://us02web.zoom.us/j/84870380096?pwd=bG5ZUmhONmZYU0I4MzlUSXMyMU0zQT09", img:"assets/imgs/sessions/C.brasselet.png"},
    ]},

    session_4:{ref:4, theme:"Session HTA : <br><span>HTA et comorbidités<br> (avec le concours des laboratoires Servier)</span>", 
    moderateurs:"M. Arharbi, R. Habbal, H. Benjelloun, S. Bensafiddine, Z. Tazi Mezalek", 
    temps:"Vendredi 16 Octobre 2020 - Après Midi / De 14H30 à 16H30",
    lives:[  
      {nom:"N. Doghmi", accro:"N.D", info:"Symposium Pfizer : Diagnostic de la cardiomyopathie amyloide trans-thyrétine", 
      zoom_co_link:"https://us02web.zoom.us/j/88435900105?pwd=U1hWcm43YkhmVHA0dU1VU2ZySHFDUT09", img:"assets/imgs/sessions/N.Doghmi.png"},

      {nom:"M. Jamili", accro:"M.J", info:"HTA et maladie coronaire", 
      zoom_co_link:"https://us02web.zoom.us/j/88435900105?pwd=U1hWcm43YkhmVHA0dU1VU2ZySHFDUT09", img:"assets/imgs/sessions/M.Jamili.png"},
      
      {nom:"T. Squalli", accro:"T.S", info:"HTA et insuffisance rénale", 
      zoom_co_link:"https://us02web.zoom.us/j/88435900105?pwd=U1hWcm43YkhmVHA0dU1VU2ZySHFDUT09", img:"assets/imgs/sessions/T.Squali.png"},
      
      {nom:"M. Nazzi", accro:"M.N", info:"HTA du sujet jeune", 
      zoom_co_link:"https://us02web.zoom.us/j/88435900105?pwd=U1hWcm43YkhmVHA0dU1VU2ZySHFDUT09", img:"assets/imgs/sessions/M.Nazzi.png"},
      
      {nom:"J. Blacher", accro:"J.B", info:"Combinaisons thérapeutiques dans l’HTA", 
      zoom_co_link:"https://us02web.zoom.us/j/88435900105?pwd=U1hWcm43YkhmVHA0dU1VU2ZySHFDUT09", img:"assets/imgs/sessions/J.Blacher.png"},
    ]},

    session_5:{ref:5, theme:"Session Insuffisance cardiaque :<br><span>nouveautés en insuffisance cardiaque</span>", 
    moderateurs:"R. Bouhouch, L. Oukerraj, M. El Hattaoui, S. Abir, M. Moughil, S. Soulami, R. Mesbahi, S. Belhaj", 
    temps:"Vendredi 16 Octobre 2020 - Après Midi / De 17H00 à 21H00",
    lives:[
      {nom:"S. Abir", accro:"S.B", info:"Insuffisance cardiaque à FE préservée : enfin du nouveau", 
      zoom_co_link:"https://us02web.zoom.us/j/88435900105?pwd=U1hWcm43YkhmVHA0dU1VU2ZySHFDUT09", img:"assets/imgs/sessions/S.Abir.png"},
      
      {nom:"N. Doghmi", accro:"N.D", info:"Imagerie multi-modalités dans l’insuffisance cardiaque", 
      zoom_co_link:"https://us02web.zoom.us/j/88435900105?pwd=U1hWcm43YkhmVHA0dU1VU2ZySHFDUT09", img:"assets/imgs/sessions/N.Doghmi.png"},
      
      {nom:"C. Leclercq", accro:"C.L", info:"Traitement électrique de l’insuffisance cardiaque", 
      zoom_co_link:"https://us02web.zoom.us/j/88435900105?pwd=U1hWcm43YkhmVHA0dU1VU2ZySHFDUT09", img:"assets/imgs/sessions/C.Leclercq.png"},
      
      {nom:"A. Bennis", accro:"A.B", info:"Symposium Bohringer : Nouveautés thérapeutiques dans l’IC : place actuelle des SGLT2 inhibiteurs", 
      zoom_co_link:"https://us02web.zoom.us/j/88435900105?pwd=U1hWcm43YkhmVHA0dU1VU2ZySHFDUT09", img:"assets/imgs/sessions/A.Bennis.png"},
      
      {nom:"A. Moustaghfir", accro:"A.M", info:"Symposium Merck : Quelle place de l'association inhibiteurs calciques et  bêtabloquant chez l’hypertendu", 
      zoom_co_link:"https://us02web.zoom.us/j/88435900105?pwd=U1hWcm43YkhmVHA0dU1VU2ZySHFDUT09", img:"assets/imgs/sessions/A.Moustaghfir.png"},

      {nom:"J.F. Obadia", accro:"J.F.O", info:"IM ischémique", 
      zoom_co_link:"https://us02web.zoom.us/j/88435900105?pwd=U1hWcm43YkhmVHA0dU1VU2ZySHFDUT09", img:"assets/imgs/sessions/J.F.Obadia.png"},

      {nom:"Ph. Pibarot ", accro:"P.P", info:"RAC et dysfonction VG", 
      zoom_co_link:"https://us02web.zoom.us/j/88435900105?pwd=U1hWcm43YkhmVHA0dU1VU2ZySHFDUT09", img:"assets/imgs/sessions/Ph.Pibarot.png"},
    ]},

    session_6:{ref:6, theme:"Prévention, réadaptation cardiaque,<br> cardiologie du sport", 
    moderateurs:"A. Khatouri, A. Chaib, N. Mouine, M. Cherti, S. Ztot", 
    temps:"Samedi 17 octobre 2020 - Matin / De 09H00 à 11H00",
    lives:[
      {nom:"A. Abreu", accro:"A.B", info:"Standarts and Quality Indicators on Cardiac Rehabilitation", 
      zoom_co_link:"https://us02web.zoom.us/j/89337891368?pwd=QXI1d3NGMy91NXpUd216dlVtbEJLdz09", img:"assets/imgs/sessions/A.Abreu.png"},
      
      {nom:"M. Alami", accro:"M.A", info:"Surmonter les obstacles à la prévention", 
      zoom_co_link:"https://us02web.zoom.us/j/89337891368?pwd=QXI1d3NGMy91NXpUd216dlVtbEJLdz09", img:"assets/imgs/sessions/M.Alami.png"},
      
      {nom:"N. Berrada", accro:"N.B", info:"HTA du sportif", 
      zoom_co_link:"https://us02web.zoom.us/j/89337891368?pwd=QXI1d3NGMy91NXpUd216dlVtbEJLdz09", img:"assets/imgs/sessions/N.Berrada.png"},
      
      {nom:"F. Carré", accro:"F.C", info:"Prévention de la mort subite chez le sportif", 
      zoom_co_link:"https://us02web.zoom.us/j/89337891368?pwd=QXI1d3NGMy91NXpUd216dlVtbEJLdz09", img:"assets/imgs/sessions/F.Carré.png"},
      
      {nom:"N. Mouine", accro:"M.N", info:"Questionnaire", 
      zoom_co_link:"https://us02web.zoom.us/j/89337891368?pwd=QXI1d3NGMy91NXpUd216dlVtbEJLdz09", img:"assets/imgs/sessions/N.Mouine.png"},

      {nom:"M. Alami", accro:"M.A", info:"Symposium Sanofi : SCA et traitement individualisé de la bithérapie antiplaquettaire : cas clinique", 
      zoom_co_link:"https://us02web.zoom.us/j/89337891368?pwd=QXI1d3NGMy91NXpUd216dlVtbEJLdz09", img:"assets/imgs/sessions/M.Alami.png"},
    ]},

    session_7:{ref:7, theme:"Joint session SMC – PAFCIC", 
    moderateurs:"H.Gamra, A. Chaara, S. Ztot, N. Bendagha", 
    temps:"Samedi 17 octobre 2020 - Matin / De 11H30 à 13H00",
    lives:[
      {nom:"A. Aouad", accro:"A.A", info:"Introduction", 
      zoom_co_link:"https://us02web.zoom.us/j/89337891368?pwd=QXI1d3NGMy91NXpUd216dlVtbEJLdz09", img:"assets/imgs/sessions/Aicha_Aouad.png"},
      
      {nom:"H. Sievert", accro:"H.S", info:"Paravalvular leak closure : case based lecture", 
      zoom_co_link:"https://us02web.zoom.us/j/89337891368?pwd=QXI1d3NGMy91NXpUd216dlVtbEJLdz09", img:"assets/imgs/sessions/H.Sievert.png"},
      
      {nom:"S. Ztot", accro:"S.Z", info:"Management of percutaneous interventions in high bleeding risk patients", 
      zoom_co_link:"https://us02web.zoom.us/j/89337891368?pwd=QXI1d3NGMy91NXpUd216dlVtbEJLdz09", img:"assets/imgs/sessions/S.Ztot.png"},
      
      {nom:"A. Pichard", accro:"A.P", info:"Latest innovations and new indications of TAVI", 
      zoom_co_link:"https://us02web.zoom.us/j/89337891368?pwd=QXI1d3NGMy91NXpUd216dlVtbEJLdz09", img:"assets/imgs/sessions/A.Pichard.png"},
      
      {nom:"H. Gamra", accro:"H.G", info:"PCI for CTO : Current indications and techniques", 
      zoom_co_link:"https://us02web.zoom.us/j/89337891368?pwd=QXI1d3NGMy91NXpUd216dlVtbEJLdz09", img:"assets/imgs/sessions/H.Gamra.png"},

      {nom:"N. Bendagha", accro:"N.B", info:"Take home message", 
      zoom_co_link:"https://us02web.zoom.us/j/89337891368?pwd=QXI1d3NGMy91NXpUd216dlVtbEJLdz09", img:"assets/imgs/sessions/N.Bendagha.png"},
    ]},

    session_8:{ref:8, theme:"Session congénitale : <br><span>les coeurs uni-ventriculaires et circulation Fontan</span>", 
    moderateurs:"R. Amri, L. Haddour, Z. Chefchaouni", 
    temps:"Samedi 17 octobre 2020 - Après-midi / De 14H00 à 15H30",
    lives:[
      {nom:"D. Bonnet", accro:"D.B", info:"Le difficile chemin vers la circulation Fontan dans les cardiopathies univentriculaires", 
      zoom_co_link:"https://us02web.zoom.us/j/84104178566?pwd=Q2pxV3ZwU3BIL2lOZThvTXZyaU1DUT09", img:"assets/imgs/sessions/D.Bonnet.png"},
      
      {nom:"M. Ladouceur", accro:"M.L", info:"Le patient adulte avec une circulation de Fontan. Complications et prise en charge", 
      zoom_co_link:"https://us02web.zoom.us/j/84104178566?pwd=Q2pxV3ZwU3BIL2lOZThvTXZyaU1DUT09", img:"assets/imgs/sessions/M.Ladouceur.png"},
      
      {nom:"S. Karimi", accro:"S.K", info:"Cas clinique : la totalisation à l’âge adulte : décision sage ou retard de prise en charge", 
      zoom_co_link:"https://us02web.zoom.us/j/84104178566?pwd=Q2pxV3ZwU3BIL2lOZThvTXZyaU1DUT09", img:"assets/imgs/sessions/S.Karimi.png"},
      
      {nom:"M. El Ghanmi", accro:"M.E", info:"Cas clinique : la joie de vivre de N ... Qui a raison ?", 
      zoom_co_link:"https://us02web.zoom.us/j/84104178566?pwd=Q2pxV3ZwU3BIL2lOZThvTXZyaU1DUT09"},
    ]},

    session_9:{ref:9, theme:"Session rythmologie : <br><span>mort subite et prolapsus valvulaire mitral</span>", 
    moderateurs:"J.C Deharo, A. Moustaghfir, A. Benyass, S. Abdelali", 
    temps:"Samedi 17 octobre 2020 - Après-midi / De 16H00 à 17H30",
    lives:[
      {nom:"M.E Sarano", accro:"M.E.S", info:"Histoire naturelle du Prolapsus valvulaire mitral", 
      zoom_co_link:"https://us02web.zoom.us/j/84104178566?pwd=Q2pxV3ZwU3BIL2lOZThvTXZyaU1DUT09", img:"assets/imgs/sessions/M.E.Sarano.png"},
      
      {nom:"C. Tribouilloy", accro:"C.T", info:"Quantification de l’IM au cours du PVM : pièges et limites", 
      zoom_co_link:"https://us02web.zoom.us/j/84104178566?pwd=Q2pxV3ZwU3BIL2lOZThvTXZyaU1DUT09", img:"assets/imgs/sessions/C.Tribouilloy.png"},
      
      {nom:"A. Tazi Mezalek", accro:"A.T.M", info:"Risque rythmique du PVM", 
      zoom_co_link:"https://us02web.zoom.us/j/84104178566?pwd=Q2pxV3ZwU3BIL2lOZThvTXZyaU1DUT09", img:"assets/imgs/sessions/A.Tazi Mezalek.png"},
      
      {nom:"A. Moustaghfir", accro:"A.M", info:"Take Home Messsages", 
      zoom_co_link:"https://us02web.zoom.us/j/84104178566?pwd=Q2pxV3ZwU3BIL2lOZThvTXZyaU1DUT09", img:"assets/imgs/sessions/A.Moustaghfir.png"},

      {nom:"JC Deharo", accro:"JC.D", info:"Symposium Bayer : La protection des patients atteints de FA et de diabète", 
      zoom_co_link:"https://us02web.zoom.us/j/84104178566?pwd=Q2pxV3ZwU3BIL2lOZThvTXZyaU1DUT09", img:"assets/imgs/sessions/JC.Deharo.png"},
    ]},

    session_10:{ref:10, theme:"Session Valvulpathies : <br><span>insuffisance aortique<br> (parrainée par la Société Française de Cardiologie)</span>", 
    moderateurs:"A. Cohen , A. Aouad, S. Chraibi", 
    temps:"Samedi 17 octobre 2020 - Après-midi / De 18H30 à 20H00",
    lives:[
      {nom:"S. Fadouach", accro:"S.F", info:"Quantification de la fuite aortique : apport de l’imagerie multi-modalités", 
      zoom_co_link:"https://us02web.zoom.us/j/84104178566?pwd=Q2pxV3ZwU3BIL2lOZThvTXZyaU1DUT09", img:"assets/imgs/sessions/S.Fadouach.png"},
      
      {nom:"A. Soufiani", accro:"A.S", info:"Fuite aortique et maladie annulo-ectasiante", 
      zoom_co_link:"https://us02web.zoom.us/j/84104178566?pwd=Q2pxV3ZwU3BIL2lOZThvTXZyaU1DUT09", img:"assets/imgs/sessions/A.Soufiani.png"},
      
      {nom:"E. Lansac", accro:"E.L", info:"Chirurgie des fuites aortiques : place de la plastie", 
      zoom_co_link:"https://us02web.zoom.us/j/84104178566?pwd=Q2pxV3ZwU3BIL2lOZThvTXZyaU1DUT09", img:"assets/imgs/sessions/E.Lansac.png"},
    ]}
  }

  selected_session = null;

  selected_live = null;

  iframe_loaded = false;

  constructor() {
    this.selected_session = this.sessions['session_1'];
    
   }

  ngOnInit() {
  }

  selectSessionByKey(key){
    this.selected_session = this.sessions[key];
  }


}
